<template>
  <BaseTitle title="Page not Found" />
  <div class="mt-5 flex self-center">
    <Button rounded small class="mt-3" @click="router.push({ name: 'homepage' })"> Back to login page </Button>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useTitle } from '@vueuse/core'
import { Button } from '@madxnl/dodo-ui'
import BaseTitle from '@/pro-targeting/components/BaseTitle.vue'

useTitle('X Deep Thought')

const router = useRouter()
</script>
